import React from 'react';
import ReactDOM from 'react-dom';
import createStore from './redux/store';
import ApiClient from './utils/ApiClient';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { ReduxAsyncConnect } from 'redux-connect';
import { hashLinkScroll } from 'utils/routeUtils';
import LocalStorage  from './localStorage';

import routes from 'routes';
const initialData = window.__data;
const client = new ApiClient();
const dest = document.getElementById('clientContent');

//bucket id for canary
if (initialData.common.canary && initialData.common.canary.featureGroups) {

  //check for local stored bucket
  const localStorage = new LocalStorage();
  let bucketId = localStorage.getValue('bucketId');
  if (!bucketId) {
    bucketId = (Math.floor(Math.random() * initialData.common.canary.maxBucketIds) + 1);
    localStorage.setValue('bucketId', bucketId);
  }

  initialData.common.canary.bucketId = bucketId;

  //set feature flags
  const featureGroups = initialData.common.canary.featureGroups
  const featuresToSet = Object.keys(featureGroups).reduce((toSet, key) => {
    if (featureGroups[key].featureNames && featureGroups[key].bucketIds.includes(bucketId)) {
      toSet = [...toSet, ...featureGroups[key].featureNames]
    }
    return toSet
  }, [])
  localStorage.setValue('features', featuresToSet)
}

const store = createStore(browserHistory, client, initialData);
const history = syncHistoryWithStore(browserHistory, store);
const component = (

  <Router render={(props) =>
        <ReduxAsyncConnect {...props} helpers={{client}} filter={item => !item.deferred} />
      } history={history}>
    {routes()}
  </Router>
);

ReactDOM.hydrate(
  <Provider store={store} key="provider">
    {component}
  </Provider>,
  dest
);



// WEBPACK FOOTER //
// ./client.js